<template>
  <div class="container">
    <h1>Users</h1>
    <div class="row justify-content-md-center">
      <div class="col col-md-9">
        <ez-input :error="errors['search']" v-model="search">Search</ez-input>
        <table class="table table-sm table-striped table-hover">
          <thead>
            <tr>
              <th>Avatar</th>
              <th>Name</th>
              <th class="d-sm-none d-md-table-cell">Roles</th>
              <th class="text-center">Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in items" :key="item._id" class="row-click">
              <td @click="$router.push({path: `/users/${item._id}`})" style="padding: .25rem;" class="text-center"><img class="avatar" :src="item.image"></td>
              <td @click="$router.push({path: `/users/${item._id}`})">
                <strong><i v-if="item.provider" :class="`fa fa-${item.provider} fa-dim`" aria-hidden="true"></i>  {{ item.name }}</strong><br>
                <div v-if="item.email">{{ item.email }}</div>
                {{ formatDate(item.createdAt) }}
              </td>
              <td @click="$router.push({path: `/users/${item._id}`})" class="d-sm-none d-md-table-cell">
                <span v-for="role in item.roles" :key="role" class="badge badge-dark">{{role.toUpperCase()}}</span>
              </td>
              <td @click="$router.push({path: `/users/${item._id}`})" class="text-center">
                <h5>
                  <span class="active" v-if="item.active"><i class="fa fa-check-circle-o" aria-hidden="true"></i></span>
                  <span class="banned" v-else><i class="fa fa-ban" aria-hidden="true"></i></span>
                </h5>
              </td>
              <td class="text-right">
                <router-link class="btn btn-primary btn-sm" :to="`/users/${item._id}/edit`" v-if="isAdmin">
                  <span class="d-sm-none d-md-inline">Edit</span>
                  <i class="fa fa-pencil d-md-none" aria-hidden="true"></i>
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import EzSwitch from "../shared/_VueEzSwitch.vue";
import EzInput from "../shared/_VueEzInput.vue";

export default {
  name: "user-index",
  data() {
    return {
      search: null,
      delayTimer: null,
      errors: [],
    };
  },
  components: {
    EzSwitch,
    EzInput,
  },
  watch: {
    // call again the method if the route changes
    $route: "getData",
    search: "searchData",
  },
  created() {
    this.getData();
    this.$embers.pageData("Users");
  },
  computed: {
    ...mapGetters(["isAdmin"]),
    ...mapState({
      items: (state) => state.users.all,
    }),
    limit() {
      return this.$route.query.limit ? this.$route.query.limit : 100;
    },
    page() {
      return this.$route.query.page ? this.$route.query.page : 1;
    },
    skip() {
      return this.limit * (this.page - 1);
    },
  },
  methods: {
    ...mapActions({
      usersAll: "users/all",
    }),
    async getData() {
      try {
        this.usersAll({
          params: `sort=-createdAt&limit=${this.limit}&skip=${this.skip}`,
        });
        this.$embers.pageData("Users");
      } catch (err) {
        console.error(err);
      }
    },
    async searchData() {
      clearTimeout(this.delayTimer);

      this.delayTimer = setTimeout(() => {
        try {
          this.usersAll({
            params: `email=${this.search}&sort=-createdAt&limit=${this.limit}&skip=${this.skip}`,
          });
          //this.usersAll({ params: { $or: [{ name: `${this.search}}` }] } });
          this.$embers.pageData("Users");
        } catch (err) {
          console.error(err);
        }
      }, 1000);
    },
    formatDate(date) {
      /* eslint-disable no-undef */
      let f = date ? moment(date).format("YYYY-MM-DD") : "";
      return f;
    },
  },
};
</script>

<style lang="scss" scoped>
h5 {
  margin-bottom: 0;
}
.avatar {
  width: 36px;
  height: 36px;
}
.active {
  color: green;
}
.banned {
  color: red;
}
</style>
